import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';

import { provideRouter, Routes } from '@angular/router';
import { HomeComponent } from './app/components/home/home.component';
import { PanelComponent } from './app/components/panel/panel.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'panel', component: PanelComponent },
  { path: '**', redirectTo: '' }
];

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),

    provideFirebaseApp(() =>
      initializeApp({
        apiKey: "AIzaSyCQ_O5uyjKzH-X4UMJS7pBdcxl5iuyIbpU",
        authDomain: "lili-oscar.firebaseapp.com",
        projectId: "lili-oscar",
        storageBucket: "lili-oscar.firebasestorage.app",
        messagingSenderId: "1052204109292",
        appId: "1:1052204109292:web:a385035c5f9345b2d744c9"
      })
    ),
    provideFirestore(() => getFirestore())
  ]
}).catch(err => console.error(err));